<template>
  <div
    class="detail-pop-box"
    :class="{ show: showDetailPop, bottomHeight: isIphoneX }"
  >
    <template v-if="!isNew">
      <div class="top-info" :class="{ canToDetail }">
        <!-- <div
          class="left-info"
          @click="lookDetail"
          :style="{
            backgroundImage:
              curScenicItem.thumb != ''
                ? `url(${curScenicItem.thumb})`
                : `url(${curClassify.icon})`,
          }"
        ></div> -->
        <div class="left-info-box" @click="lookDetail">
          <img :src="curScenicItem.thumb != '' ? curScenicItem.thumb : curClassify.icon" alt="">
          <span class="canToDetail-span">{{ $t('main["详情"]') }}</span>
        </div>
        <div class="right-info">
          <div class="title">
            {{ curScenicItem["title"] }}
            <!-- <span class="distance">距您{{curScenicItem['distance']/1000}}km</span> -->
            <span class="distance" v-if="!isNotWeiXin">{{ $t('main["距您"]') }}{{ curScenicItem["distance"] }}</span>
          </div>
          <div class="subtitle">{{ curScenicItem["subtitle"] }}</div>
        </div>
        <div class="close-btn" @click="closePop"></div>
      </div>
      <div class="center-info">
        <!-- 1景点 2美食 3住宿 4购物 -->
        <p
          class="time"
          :class="{'time-scenic':scenic==1}"
          v-if="
            (curScenicItem.ctype == 1 ||
            curScenicItem.ctype == 2 ||
            curScenicItem.ctype == 3 ||
            curScenicItem.ctype == 4) && curScenicItem['opentime']
          "
        >
          {{ $t('main["营业时间"]') }}：{{ curScenicItem["opentime"] }}
        </p>
        <p class="address" :class="{'address-scenic':scenic==1}" v-if="curScenicItem['address']">{{ $t('main["地址"]') }}：{{ curScenicItem["address"] }}</p>
        <p
          class="telphone"
          :class="{'tel-scenic':scenic==1}"
          v-if="
            (curScenicItem.ctype == 1 ||
            curScenicItem.ctype == 2 ||
            curScenicItem.ctype == 3 ||
            curScenicItem.ctype == 4) && curScenicItem['telphone']
          "
        >
          <span class="callPhone" v-if="isHarmonyosIdentifying" @click="callPhone(curScenicItem.telphone)">{{ $t('main["电话"]') }}：<span>{{ curScenicItem["telphone"] }}</span></span>
          <a v-else :href="`tel:+${curScenicItem['telphone']}`">{{ $t('main["电话"]') }}：<span>{{ curScenicItem["telphone"] }}</span></a>
        </p>
      </div>
      <div class="btn-box">
        <!-- <a href="javascript:void(0);" @click="gotoDetail" class="go-detail" v-if="(curScenicItem.ctype == 1 || curScenicItem.ctype == 2 || curScenicItem.ctype == 3) && curScenicItem.cstatus == 2">查看详情</a> -->
        <a
          href="javascript:void(0);"
          v-if="curScenicItem.audio != ''"
          @click="playAudios($event, curScenicItem)"
          class="go-detail"
          :class="{'go-detail-scenic':scenic==1, 'reward':curScenicItem['question'] && curScenicItem['question']['id'], 'isPlay': playStatus}"
          >{{ $t( `main["${ curAudioSpotId == curScenicItem.id ? ["语音讲解", "暂停", "继续"][playStatus] : '语音讲解' }"]` )}}</a
        >
        <a href="javascript:void(0);" :class="{'gohere-scenic':scenic==1}" @click="goHere">{{ $t('main["到这里去"]') }}</a>
        <a href="javascript:void(0);" class="go-detail go-vedio" v-if="vedios.length" :class="{'go-detail-scenic':scenic==1}" @click="$emit('playVedio')">{{ $t('main["视频讲解"]') }}</a>
      </div>
    </template>
    <!-- 改版 -->
    <template v-else>
      <div class="detail-content">
        <img class="img" :src="curScenicItem.thumb != '' ? curScenicItem.thumb : curClassify.icon" alt="" @click="lookDetail">
        <div class="right">
          <div class="title">
            <div class="tit">{{ curScenicItem["title"] }}</div>
            <div class="distance">{{ $t('main["距您"]') }}{{ curScenicItem["distance"] }}</div><!--  v-if="!isNotWeiXin" -->
          </div>
          <div class="tips" v-if=" (curScenicItem.ctype == 1 || curScenicItem.ctype == 2 || curScenicItem.ctype == 3 || curScenicItem.ctype == 4) && curScenicItem['opentime']">
            <span class="val">{{ $t('main["营业时间"]') }}：{{ curScenicItem["opentime"] }}</span>
          </div>
          <div class="tips" v-if="curScenicItem['address']">
            <span class="val">{{ $t('main["地址"]') }}：{{ curScenicItem["address"] }}</span>
          </div>
          <div class="tips" v-if=" (curScenicItem.ctype == 1 || curScenicItem.ctype == 2 || curScenicItem.ctype == 3 || curScenicItem.ctype == 4) && curScenicItem['telphone'] ">
            <span class="val" v-if="isHarmonyosIdentifying" @click="callPhone(curScenicItem.telphone)">{{ $t('main["电话"]') }}：{{ curScenicItem["telphone"] }}</span>
            <a class="val" v-else :href="`tel:+${curScenicItem['telphone']}`">{{ $t('main["电话"]') }}：{{ curScenicItem["telphone"] }}</a>
          </div>
        </div>
      </div>
      <div class="detail-btns" :class="{ 'no-btn': curScenicItem.audio == '' && !vedios.length }">
        <div
          v-if="curScenicItem.audio != ''"
          @click="playAudios($event, curScenicItem)"
          class="btn"
          :class="{'reward': hasQuestion, 'isPlay': playStatus}"
          >{{ $t( `main["${ curAudioSpotId == curScenicItem.id ? ["语音讲解", "暂停", "继续"][playStatus] : '语音讲解' }"]` )}}
          </div>
        <div class="btn" v-if="vedios.length" :class="{'go-detail-scenic':scenic==1}" @click="$emit('playVedio')">{{ $t('main["视频讲解"]') }}</div>
        <div class="go-here" @click="goHere" v-if="isWeiXin">
          <img class="icon" src="./../../assets/new-style/icon_GoHere@2x.png" alt="">
          <span class="tit">{{ showArBtn ? $t(`main["AR导航"]`) : $t(`main["去这里"]`)  }}</span>
        </div>
      </div>
    </template>
    <!-- 语言弹框 -->
    <!-- <mt-actionsheet :actions="audiolist" v-model="showAudioSelectBox"></mt-actionsheet> -->
    <div class="audio-box" v-show="showAudioSelectBox && showDetailPop">
      <div class="audio-title">
        <div class="robot"></div>
        <span class="tit">{{ $t('main["选择语言"]') }}</span>
        <div class="play-icon"></div>
        <div class="audio-close" @click="closeLan"></div>
      </div>
      <div class="languages">
        <div class="list">
          <div
            class="lan-item"
            @click="chooseLan(index, item)"
            v-for="(item, index) in audiolist"
            :key="index"
          >
            <div class="name">
              <span class="lan-icon" :style="{'background-image':'url('+ item.icon +')'}"></span>
              <span>{{ item.name }}</span>
            </div>
            <div class="dot" :class="{ dotActive: index == lanIndex }"></div>
          </div>
        </div>
        <div class="wave"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Apis from '../../config/apis'
import _ from '../../config/util'
export default {
  name: 'detailPopup',
  props: {
    url: {
      type: String,
    },
  },
  data() {
    return {
      sid: this.$route.query.id,
      showAudioSelectBox: false, // 是否显示播放音乐弹框
      audiolist: [], // 当前语音列表
      playStatus: 0, // 播放状态 0未播放 1正在播放 2暂停
      curScenicElementNode: null, // 当前点击的音频播放按钮节点
      lanIndex: 0,
      scenic: '',
      questionAudio:{},
      isNotWeiXin: false, // 不为微信环境 指浏览器打开
      curAudioSpotId: '', // 最后播放的音频所属景点id
      vedios: [],
      uid: this.$route.query.uid,
    }
  },
  computed: {
    // 获取当前显示状态
    showDetailPop() {
      // 显示点
      if(this.$store.state.showDetailPop && this.scenic == 1) {
        this.getVedio()
      }
      return this.$store.state.showDetailPop
    },
    // 获取当前选中的点信息
    curScenicItem() {
      return this.$store.state.curScenicItem
    },
    // 当前分类
    curClassify() {
      return this.$store.state.curClassify
    },
    // 当前分类
    isWeiXin() {
      return this.$store.state.isWeiXin
    },
    isIphoneX() {
      return !(this.$route.query.isIphoneX == 'false')
    },
    isHarmonyosIdentifying() {
      return this.$store.state.isHarmonyosIdentifying
    },
    // 是否支持跳转
    canToDetail(){
      // return this.scenic && (['1', '2', '3', '4', '7'].includes(this.curScenicItem.ctype)) && this.curScenicItem.id
      // return this.scenic && (['1', '2', '3', '4', '5', '6', '7', '9'].includes(this.curScenicItem.classifyid)) && this.curScenicItem.id
      // 2022/9/13改为景区通全部可以跳转
      // 2024/6/24 高德点位不能跳转
      return this.scenic && this.curScenicItem.id
    },
    isNew() {
      return this.$store.state.isNew
    },
    
    // 获取所有景点信息
    curScenicList() {
      return this.$store.state.curScenicList
    },
    userLocation() {
      return this.$store.state.userLocation
    },
    hasAr() {
      return true
      return this.$route.query.hasAr
    },
    showArBtn() {
      if(!this.hasAr || !this.curScenicItem) return false
      let showArDistance = 3

      let distance = this.curScenicItem.distance
      if(distance?.match(/km|KM/)) { // 公里
        return parseFloat(distance) <= showArDistance
      } else if(distance?.match(/m|M/)) { // 米
        return parseFloat(distance) <= (showArDistance * 1000)
      }
      return false
    },
    questionPointList() {
      return this.$store.state.questionPointList
    },
    hasQuestion() {
      if(!this.curScenicItem?.id) return false
      return this.questionPointList.find(v => v.id == this.curScenicItem.id)
    },
    // 是否为付费音频
    paidVoice() {
      // 语音开启付费并且还没支付
      return this.curScenicItem.audio_is_payment == 1 && this.curScenicItem.is_paid != 1
    }
  },
  watch:{
    showDetailPop(status){
      // 显示景点详情
      if (status) {
        this.autoPlay()
        // 当显示景点详情时，隐藏推荐路线弹窗、搜索弹窗、POI弹窗
        if(window.hideSearchBoxFun) window.hideSearchBoxFun()
        window.hideRouteDetailFun()
        window.hidePOIBox()
      }
    },
    curScenicItem(data){
      // 查看的景点变更
      if (data && this.showDetailPop) this.autoPlay()
    }
  },
  mounted(){
    //  this.scenic = !!(this.$route.query.scenic - 0)
     this.scenic = !!(1 - 0)
     this.isNotWeiXin = (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) != 'micromessenger') || (window.navigator.userAgent.toLowerCase().match(/aweme/i) == 'aweme')
  },
  methods: {
    // 关闭语言选择弹窗
    closeLan() {
      this.showAudioSelectBox = false
    },
    // 选择语言
    chooseLan(index, item) {
      // console.log('****',index)
      this.lanIndex = index
      this.playAudio(item,item.question)
    },
    /**
     * 查看详情
     */
    lookDetail() {
      if(!this.isWeiXin) return
      // 2022/3/18 景区通娱乐、住宿分类点击图片也可跳转
      // 2022/4/19 景区通h5也可跳转
      // 2022/5/31 美食也能跳转
      // if (this.scenic && (this.curScenicItem.ctype == 1 || this.curScenicItem.classify === '娱乐' || this.curScenicItem.classify === '住宿') && this.curScenicItem.id) {
      if (this.canToDetail) {
        let url = `pages/scenic/detail/index?id=${this.curScenicItem.id}&category=${ this.curScenicItem.category }${ this.sid ? '&isScenic=1' : '' }`
        if(this.isWeiXin) {
          window.uni.miniProgram.navigateTo({
            url: `/${url}`,
          })
        } else {
          window.location.href = `${this.$scenicUrl}${url}`
        }
      }
      return false
      console.log('*****curScenicItem', this.curScenicItem)
      // return;
      if (this.isWeiXin) {
        // 景点详情
        if (this.curScenicItem.ctype == 1) {
          window.uni.miniProgram.navigateTo({
            url: `/packages/city_service/scenic/detail/index?id=${this.curScenicItem.id}`,
          })
        }
        // 美食详情
        if (this.curScenicItem.ctype == 2 || this.curScenicItem.ctype == 3) {
          window.uni.miniProgram.navigateTo({
            // url: `/pages/guide/detail/index?id=${this.curScenicItem.id}&type=${this.curScenicItem.ctype == 2 ? 2 : 1}`
            url: `/packages/food/detail/index?id=${
              this.curScenicItem.id
            }&type=${this.curScenicItem.ctype == 2 ? 2 : 1}`,
          })
        }
      } else {
        // 景点详情
        if (this.curScenicItem.ctype == 1) {
          window.location.href = `${this.$baseurl}packages/city_service/scenic/detail/index?id=${this.curScenicItem.id}`
        }
        // 美食详情
        if (this.curScenicItem.ctype == 2 || this.curScenicItem.ctype == 3) {
          // window.location.href = `${this.$baseurl}pages/guide/detail/index?id=${this.curScenicItem.id}&type=${this.curScenicItem.ctype == 2 ? 2 : 1}`
          window.location.href = `${
            this.$baseurl
          }packages/food/detail/index?id=${this.curScenicItem.id}&type=${
            this.curScenicItem.ctype == 2 ? 2 : 1
          }`
        }
      }
    },
    // 播放语音
    playAudios(e, item) {
      // 付费音频
      if(this.paidVoice) {
        this.$emit('showPaidVoice', this.curScenicItem)
        return
      }
      let url = item.audio
      const audio = document.getElementById('audio-dom')
      // console.log('****audio',audio)
      if (url.length == 1) { // 单音频
        // console.log('url.length*******进来了',url[0])
        url[0]['el'] = e.srcElement
        this.playAudio(url[0],item.question)
      } else { // 多音频
        console.log('*****playstatus', this.playStatus)
        // 同一个景点 并且正在播放
        if(this.curAudioSpotId == this.curScenicItem.id && this.playStatus == 1) {
          audio.pause()
          this.playStatus = 2
          // e.currentTarget.firstChild.style.display = 'none'

        // 同一个景点 并且暂停了
        } else if (this.curAudioSpotId == this.curScenicItem.id && this.playStatus == 2){
          audio.play()
          this.playStatus = 1
        } else {
          console.log('***显示详情，多个语音')
          // 显示详情
          // this.$store.commit('setDetailPopupStatus', false);
          const audioShowList = []
          // 处理音频列表数据
          url.forEach((el) => {
            audioShowList.push({
              name: el.title,
              method: this.playAudio,
              // el: e.currentTarget.firstChild,
              el: e.srcElement,
              url: el.url,
              icon: el.icon,
              question:item.question
            })
          })
          this.audiolist = audioShowList
          // 存储当前点击的marker上的音频按钮节点
          this.curScenicElementNode = e
          this.showAudioSelectBox = true
          // console.log('*****是否弹窗',this.showAudioSelectBox)
        }
      }
    },
    // 播放音频
    playAudio(data,question) {
      this.curAudioSpotId = this.curScenicItem.id
      const audio = document.getElementById('audio-dom')
      if(audio.src !== data.url){
        audio.src = data.url // 避免暂停后点击播放会从头开始
        this.playStatus = 0
      }
      if (this.playStatus == 1) {
        audio.pause()
        this.playStatus = 2 // false
        // data.el.style.display = 'none'
      } else {
        audio.play()
        this.playStatus = 1 // true
        // data.el.style.display = 'block'
      }
      // 调整监听方式 addEventListener => onended 处理多次点击事件过多问题
      audio.onended = () => {
        this.playStatus = 0 // false
        this.$emit('audioEnd')
        if(this.hasQuestion){
          this.axios.post(Apis.questionQuestion, {
            sid: this.curScenicItem.id,
            uid: this.uid
          }).then(res => {
            this.$emit('showAnswer',res.data)
          })
        }
        // data.el.style.display = 'none'
      }
      // 隐藏弹框
      this.showAudioSelectBox = false
    },
    /**
     * 去详情
     */
    gotoDetail() {
      if (this.isWeiXin) {
        // 高德查询出来的点位不给进入详情页
        if(!this.curScenicItem.id) return
        // 景点详情
        if (this.curScenicItem.ctype == 1) {
          window.uni.miniProgram.navigateTo({
            url: `/packages/city_service/scenic/detail/index?id=${this.curScenicItem.id}`,
          })
        }
        // 美食详情
        if (this.curScenicItem.ctype == 2 || this.curScenicItem.ctype == 3) {
          window.uni.miniProgram.navigateTo({
            url: `/packages/city_service/scenic/detail/index?id=${
              this.curScenicItem.id
            }&type=${this.curScenicItem.ctype == 2 ? 2 : 1}`,
          })
        }
      } else {
        // console.log('***curSc',this.curScenicItem)
        return
        // 景点详情
        if (this.curScenicItem.ctype == 1) {
          // window.uni.miniProgram.navigateTo({
          //     url: `/packages/map/scenic-detail/index?id=${this.curScenicItem.id}`
          // });
          //http://scenic.test.tuliyou.com/web
          window.location.href = `${this.$baseurl}packages/city_service/scenic/detail/index?id=${this.curScenicItem.id}`
        }
        // 美食详情
        if (this.curScenicItem.ctype == 2 || this.curScenicItem.ctype == 3) {
          // window.uni.miniProgram.navigateTo({
          //     url: `/packages/index/food-detail/index?id=${this.curScenicItem.id}&type=${this.curScenicItem.ctype == 2 ? 2 : 1}`
          // });
          window.location.href = `${
            this.$baseurl
          }packages/city_service/scenic/detail/index?id=${
            this.curScenicItem.id
          }&type=${this.curScenicItem.ctype == 2 ? 2 : 1}`
        }
      }
    },
    /**
     * 导航
     */
    goHere() {
      if (this.isWeiXin) {
        if(this.showArBtn) {
          // 获取与当前点位距离3公里以内的景点列表
          let list = this.curScenicList.filter(v =>( _.getTwoPointsDistance({latitude: this.userLocation[1], longitude: this.userLocation[0]}, {latitude: v.lat, longitude: v.lng}) <= 3000) && v.id != this.curScenicItem.id).map(v => ({
            name: v.title,
            location: {
              longitude: v.lng,
              latitude: v.lat
            }
          }))
          window.uni.miniProgram.navigateTo({
            url: 'plugin://ar-walking-navigation/ar-page?params=' + JSON.stringify({
              name: this.curScenicItem.title, // 配置目的地名字
              location: {
                  longitude: this.curScenicItem.lng, // 目的地经度
                  latitude: this.curScenicItem.lat // 目的地纬度
              },
              // tencentMapKey: '3GOBZ-3RV34-YNUUY-DY74J-PZAVS-VNBG7', // 腾讯地址服务申请的地图key [可选，与aMapKey同时存在时，使用tencentMapKey]
              tencentMapKey: '', // 腾讯地址服务申请的地图key [可选，与aMapKey同时存在时，使用tencentMapKey]
              aMapKey: '695abc2cc03956bb449e270b3be43e87', // 高德地址服务申请的地图key [可选]
              moreLocations: [ // 设置除目标外的其他地点，显示名字及直线距离 [可选]
                // ...this.curScenicList.filter(v => parseFloat(v.distance) <= 3 && v.id != this.curScenicItem.id).map(v => ({
                //   name: v.title,
                //   location: {
                //     longitude: v.lng,
                //     latitude: v.lat
                //   }
                // }))
                ...list
                // {
                //   name: '狮驼岭',
                //   location: {
                //     longitude: this.lng + 0.001,
                //     latitude: this.lat + 0.001
                //   }
                // }
              ],
              mapConfig: { // 地图细节配置 [可选]
                showMap: true, // 是否显示地图
                showTip: true // 是否显示地图上方的路径步骤详情
              },
              audioTip: true,
              models: [ // 放置3d模型，旗舰版功能
                // {
                //   // 模型放置模式，left：指示箭头左侧，center：指示箭头前方，right：指示箭头右侧，location：固定坐标位置
                //   type: 'left',
                //   // 数字人模型地址 可以是自定义模型的https网络地址 也可选插件默认形象(默认形象有：default_1、 default_2...)
                //   // model: 'default_1',
                //   model: 'https://ts.hbysp.cn/ss.min.glb',
                //   // location: { // 模型固定放置在某个坐标位置(仅type为location时候有效)
                //   //   longitude: 121.28043,
                //   //   latitude: 31.325665,
                //   //   showDiatance: 100, // 用户距离该位置多少米时显示模型
                //   // },
                //   scale: 4, // 模型尺寸缩放
                //   rotate: 0, // 旋转角度，坐标位置定位时相对北方；跟随指示箭头附近时相对箭头反方向(面向镜头方向)
                //   animations: { // 模型动画名称匹配
                //     forward: 'BackCharge', // 向前进
                //     beckon: ['Waving', 'Dance1', 'Dance2'], // 打招呼，数组类型随机选其中一个
                //     idle: 'Idle', // 空闲
                //     looking: 'Looking', // 查看寻找
                //     dance: ['Dance1', 'Dance2'], // 跳舞，数组类型随机选其中一个
                //   }
                // }
                {
                  type: 'left',
                  model: 'https://ts.hbysp.cn/ss.min.glb',
                  // model: 'https://s.desmix.com/glb/model/tmp/ss.min.glb',
                  scale: 14,
                  rotate: 0,
                  animations: {
                    forward: 'shuohua', // 向前进
                    beckon: 'shuohua', // 打招呼，数组类型随机选其中一个
                    idle: 'daiji', // 空闲
                    looking: 'shuohua', // 查看寻找
                    dance: 'shuohua', // 跳舞，数组类型随机选其中一个
                  }
                }
              ],
            })
          })
          
          return
        }
        // 打开地址
        let openLocation = window.uni.openLocation
        if (!openLocation && window.uni.miniProgram.openLocation) openLocation = window.uni.miniProgram.openLocation
        openLocation({
          latitude: this.curScenicItem.lat, // 纬度，浮点数，范围为90 ~ -90
          longitude: this.curScenicItem.lng, // 经度，浮点数，范围为180 ~ -180。
          name: this.curScenicItem.title, // 位置名
          address: this.curScenicItem.address, // 地址详情说明
        })
      } else {
        
        if(this.isHarmonyosIdentifying) {
          window.JsCallbackToNavi.call(`${ this.curScenicItem.title },${ this.curScenicItem.lat },${ this.curScenicItem.lng }`)
          return
        }

        this.$emit('showQrcode')

        return
        // 百度
        // window.location.href =`http://api.map.baidu.com/marker?location=${this.curScenicItem.lat},${this.curScenicItem.lng}&title=${this.curScenicItem.title}&content=${this.curScenicItem.address}&output=html`
        //高德
        window.location.href = `https://uri.amap.com/marker?position=${this.curScenicItem.lng},${this.curScenicItem.lat}&name=${this.curScenicItem.title}`
      }
    },
    /**
     * 关闭弹窗
     */
    closePop() {
      this.$store.commit('setDetailPopupStatus', false)
    },
    getVedio(){
      if(!this.curScenicItem || !this.curScenicItem.id) return
      this.vedios = []
      let vedios = []
      if(this.curScenicItem.video) {
        vedios = [{
          video_img: 'https://scenic.test.tuliyou.com/upload/uediter/image/20240301/1709284877575058.jpg',
          video_link: this.curScenicItem.video,
          video_show: '1',
          video_species: {text: '上传视频', value: '1'},
          video_species_feed_id: '',
          video_species_id: '',
          video_sub_title: '1',
          video_tencent_id: '',
          video_title: '测试视频',
        }]
      }
      this.vedios = vedios
      this.$emit('getVedio', vedios)
      // this.axios.post(Apis.viewpointVideos, {
      //   viewpoint_id: this.curScenicItem.id,
      //   page: 1,
      //   limit: 999
      // }).then((res) => {
      //   let vedios = res.data.filter(v => v.video_species.value != 2 && v.video_species.value != 3) // 过滤视频号及腾讯视频
      //   this.vedios = vedios
      //   this.$emit('getVedio', vedios)
      // })
    },
    autoPlay(){
      // this.playStatus != 1 && 
      // 有音频存在 并且现在要播放的音频所属景点不是上个播放的音频的景点，或者现在播放的音频和上个播放的音频的景点是同一个并且上个音频没有正在播放
      if(this.curScenicItem.audio.length && (this.curAudioSpotId != this.curScenicItem.id || (this.curAudioSpotId == this.curScenicItem.id && this.playStatus != 1))) {
        // 付费音频不自动播放
        if(this.paidVoice) {
          return
        }
        // 如果当前要播放的音频所属景点跟上个播放的音频景点不相同的话重置播放状态
        if(this.curAudioSpotId != this.curScenicItem.id) this.playStatus = 0
        this.playAudios({}, this.curScenicItem)
      }
    },
    callPhone(phone) {
      if(this.isHarmonyosIdentifying) {
					window.JsCallbackToCall.call(phone)
				}
    }
  },
}
</script>

<style scoped lang='scss'>
.detail-pop-box {
  width: 100%;
  position: fixed;
  bottom: 1rem;
  // left: 0.2rem;
  // right: 0.2rem;
  // z-index: 1001;
  z-index: 1000;
  background: #fff;
  font-size: 0.26rem;
  padding: 0.1rem 0.3rem 0.2rem;
  transform: translateY(200%);
  border-radius: 0.2rem 0.2rem 0 0;
  text-align: left;
  transition: all 0.3s;
  border-bottom: 1px solid #ccc;
  // box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);

  &.show {
    transform: translateY(0);
  }

  .top-info {
    position: relative;
    display: flex;
    align-items: center;
    // min-height: 1rem;
    // padding-left: 1.1rem;
    padding-left: 1.5rem;
    padding-bottom: .1rem;

    .left-info {
      position: absolute;
      top: -0.35rem;
      left: 0;
      border-radius: 50%;
      border: 0.06rem solid #fff;
      overflow: hidden;
      width: 1rem;
      height: 1rem;
      background-size: cover;
      background-repeat: no-repeat;
      img {
        display: none;
      }
    }

    .left-info-box {
      position: absolute;
      top: -0.7rem;
      left: .1rem;
      border-radius: 50%;
      padding: .05rem;
      background: #ffffff;
      display: flex;
      // width: 1.rem;
      // height: 1.4rem;
      img {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
      }
      .canToDetail-span {
        display: none;
      }
      
    }
    &.canToDetail {
      padding-left: 1.7rem;
      padding-bottom: 0;
      .left-info-box {
        border: .07rem solid #67AAF6;
        .canToDetail-span {
          display: inline-block;
          font-size: .2rem;
          font-weight: bold;
          color: #FFFFFF;
          width: .61rem;
          height: .28rem;
          background: linear-gradient(0deg, #67AAF6 0%, #6FC0F8 100%);
          box-shadow: .01rem .01rem .02rem 0 rgba(29,92,214,0.5000);
          border-radius: .1rem;
          border: .03rem solid #ffffff;
          text-align: center;
          line-height: .28rem;
          position: absolute;
          bottom: -0.1rem;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }
    }

    .right-info {
      flex: 1 1 auto;
      min-height: .6rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .title {
        font-size: 0.3rem;
      }
      .subtitle {
        color: #888;
        font-size: 0.22rem;
        line-height: 0.36rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .distance {
        font-size: 0.2rem;
        color: #666666;
      }
    }
    .close-btn {
      position: absolute;
      top: 0.05rem;
      right: 0;
      width: 0.4rem;
      height: 0.4rem;
      background: url(../../assets/close_icon.png) no-repeat center center /
        0.4rem 0.4rem;
    }
  }

  .center-info {
    width: 100%;
    color: #888;
    font-size: 0.24rem;
    padding: 0.2rem 0 .3rem;
    box-sizing: border-box;
    p {
      padding-left: 0.4rem;
      margin-bottom: 0.1rem;
    }
    .time {
      background: url(../../assets/time_icon.png) no-repeat left 0 / 0.3rem
        0.3rem;
    }
    .time-scenic {
      background: url(../../assets/time-sc.png) no-repeat left 0 / 0.3rem
        0.3rem;
    }
    .address {
      background: url(../../assets/address_icon.png) no-repeat left 0 / 0.3rem
        0.3rem;
    }
    .address-scenic {
      background: url(../../assets/location-sc.png) no-repeat left 0 / 0.3rem
        0.3rem;
    }
    .telphone {
      background: url(../../assets/telphone_icon.png) no-repeat left 0 / 0.3rem
        0.3rem;
      
      a, .callPhone {
        color: inherit;
        text-decoration: none;
        span {
          color: #67AAF6;
        }
      }
    }
    .tel-scenic{
       background: url(../../assets/phone-sc.png) no-repeat left 0 / 0.3rem
        0.3rem;
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    flex-wrap: nowrap;
    align-items: center;
    padding-bottom: 0.02rem;
    a {
      display: inline-block;
      // background: linear-gradient(to left, #48c1ff, #4db4d5);
      background: linear-gradient(0deg, #1498ec 0%, #48c1ff 100%);
      color: #fff;
      // padding: 0 1rem;
      flex: 1;
      border-radius: 0.4rem;
      text-decoration: none;
      border: 0.01rem solid #48c1ff;
      height: 0.6rem;
      line-height: 0.6rem;
      text-align: center;
      max-width: 3.1rem;

      &.go-detail {
        background: transparent;
        border: 0.01rem solid #48c1ff;
        color: #48c1ff;
        margin-right: 0.3rem;
      }
      &.go-detail-scenic {
        background: transparent;
        border: 0.01rem solid #009D7A;
        color: #009D7A;
        margin-right: 0.3rem;
      }
      &.go-vedio {
        margin-right: 0;
        margin-left: .3rem;
      }
      &.reward{
        background: linear-gradient(180deg, #FCD035 0%, #FFB505 100%);
        box-shadow: 0rem 0.06rem 0rem 0rem #EEA127;
        border: 0;
        border-radius: 0.27rem;
        height: 0.54rem;
        // line-height: 0.6rem;
        color: #ffffff;
        margin-bottom: 0.03rem;
        position: relative;
        &::after{
          content: '';
          width: 0.5rem;
          height: 0.5rem;
          background: url(../../assets/prize_star.png);
          background-size: 100% 100%;
          display: inline-block;
          position: absolute;
          right: -0.2rem;
          top: -0.25rem;
        }
      }
    }
    .gohere-scenic{
      background: linear-gradient(0deg, #009D7A 0%, #00C89C 100%);
    }
  }
  .audio-box {
    width: 5.5rem;
    // height: 3.44rem;
    background: #748bf6;
    border-radius: 20px;
    position: fixed;
    top: -40vh;
    left: 0;
    right: 0;
    margin: auto;
    padding-bottom: 0.1rem;
    .audio-title {
      position: relative;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      padding-top: 0.2rem;
      .robot {
        width: 1.23rem;
        height: 1.59rem;
        background: url("../../assets/robot.png") no-repeat center;
        background-size: cover;
        position: absolute;
        top: -0.79rem;
        left: 0.4rem;
      }
      .play-icon {
        width: 0.46rem;
        height: 0.46rem;
        background: url("../../assets/audio-play.png") no-repeat center;
        background-size: cover;
        position: absolute;
        top: 0.23rem;
        right: 1.16rem;
      }
      .audio-close {
        width: 0.4rem;
        height: 0.4rem;
        background: url("../../assets/audio-close.png") no-repeat center;
        background-size: cover;
        position: absolute;
        top: 0.23rem;
        right: 0.33rem;
      }
    }
    .languages {
      width: 100%;
      min-height: 2.4rem;
      background: #ffffff;
      border-radius: 20px;
      margin-top: 0.1rem;
      position: relative;
      .list {
        padding: 0 0.42rem;
        .lan-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 1.25rem;
          border-bottom: 1px solid #eee;
          .name {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            .lan-icon {
              display: inline-block;
              width: 0.4rem;
              height: 0.4rem;
              // background: url("../../assets/en.png") no-repeat center;
              background-size: cover;
              vertical-align: bottom;
              margin-right: 0.2rem;
            }
          }
          .dot {
            width: 0.3rem;
            height: 0.3rem;
            background: #eeeeee;
            border-radius: 50%;
          }
          .dotActive {
            background: #748bf6;
            position: relative;
            &::after {
              content: "";
              display: inline-block;
              width: 0.14rem;
              height: 0.14rem;
              background: #ffffff;
              border-radius: 50%;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;
            }
          }
        }
      }
      .wave {
        width: 100%;
        height: 0.68rem;
        background: url("../../assets/wave.png") no-repeat center;
        background-size: cover;
        position: absolute;
        bottom: 0;
        left: 0;
        pointer-events: none;
      }
    }
  }
}
.bottomHeight {
  bottom: 1.4rem;
}


</style>
